module.exports = __webpack_public_path__ + "media/images/lp_modal-image_small_people-443de058c143639ee057c125cf2fb465.webp";